<template>
    <div class="max-w-screen-xl px-4 py-10 mx-auto lg:py-20">
        <div class="mx-auto text-center h2 font-ww-light lg:text-5xl" v-html="mainTitle"></div>

        <div class="grid items-center grid-cols-12 mt-10">
            <div class="col-span-12 md:col-span-5">
                <div class="max-w-md mx-auto text-center uppercase h3 font-ww-light text-balance" v-html="subTitle"></div>
                <div>
                    <nuxt-img :width="firstImageWidth" :height="firstImageHeight" format="webp" :src="firstImageSrc"
                        alt="section image" class="w-full mx-auto" loading="lazy"
                        sizes="xs:320px sm:440px md:601px lg:436px xl:436px" />
                </div>
            </div>
            <div class="col-span-12 md:col-span-7">
                <nuxt-img :width="secondImageWidth" :height="secondImageHeight" format="webp" :src="secondImageSrc" alt="section image"
                    class="w-full mx-auto" loading="lazy" sizes="xs:300px sm:440px md:745vw lg:487px xl:600px" />
            </div>
        </div>

        <div class="mt-10">
            <button @click="scrollTo(buttonLink)" class="w-full bg-[#00963f] text-white py-4 rounded-md uppercase font-bold text-center inline-block" style="box-shadow:0 -4px 0 #005d27 inset;" v-html="buttonText">
            </button>
        </div>
    </div>
</template>

<script setup>

const props = defineProps({
    mainTitle: {
        type: String,
        default: 'The #1 organic coffee on RoastyCoffee.com! and Coffee Channel!'
    },
    subTitle: {
        type: String,
        default: 'everyone is talking about lifeboost coffee including:'
    },
    firstImageSrc: {
        type: String,
        default: '/assets/images/organic-1.png'
    },
    firstImageWidth: {
        type: Number,
        default: 436
    },
    firstImageHeight: {
        type: Number,
        default: 590
    },
    secondImageSrc: {
        type: String,
        default: '/assets/images/organic-2.png'
    },
    secondImageWidth: {
        type: Number,
        default: 601
    },
    secondImageHeight: {
        type: Number,
        default: 665
    },
    buttonText: {
        type: String,
        default: 'shop lifeboost coffee'
    },
    buttonLink: {
        type: String,
        default: 'the-products' // default link
    }
});

defineBuilderComponent({
    friendlyName: 'Title With Image CTA',
    inputs: [
        {
            name: 'mainTitle',
            type: 'richText',
            defaultValue: 'The #1 organic coffee on RoastyCoffee.com! and Coffee Channel!'
        },
        {
            name: 'subTitle',
            type: 'richText',
            defaultValue: 'everyone is talking about lifeboost coffee including:'
        },
        {
            name: 'firstImageSrc',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'svg', 'png'],
            defaultValue: '/assets/images/organic-1.png'
        },
        {
            name: 'firstImageWidth',
            type: 'number',
            defaultValue: 436
        },
        {
            name: 'firstImageHeight',
            type: 'number',
            defaultValue: 590
        },
        {
            name: 'secondImageSrc',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'svg', 'png'],
            defaultValue: '/assets/images/organic-2.png'
        },
        {
            name: 'secondImageWidth',
            type: 'number',
            defaultValue: 601
        },
        {
            name: 'secondImageHeight',
            type: 'number',
            defaultValue: 665
        },
        {
            name: 'buttonText',
            type: 'richText',
            defaultValue: 'shop lifeboost coffee'
        },
        {
            name: 'buttonLink',
            type: 'text',
            defaultValue: 'the-products' // default link
        }
    ]
});
</script>
